import React, { useEffect, useRef, useState } from 'react';

type useStateRefType<T> = {
  value: T;
  setValue: React.Dispatch<React.SetStateAction<T>>;
  valueRef: React.MutableRefObject<T>;
};
export function useStateRef<T>(initialValue: T): useStateRefType<T> {
  const [value, setValue] = useState<T>(initialValue);
  const valueRef = useRef<T>(initialValue);

  useEffect(() => {
    valueRef.current = value;
    setValue(value);
  }, [value]);

  return { value, setValue: (newValue) => setValue(newValue), valueRef };
}
